import { useLoadingBar } from 'naive-ui'

const LoadingBarContent = () => {
  const loadingBar = useLoadingBar()

  window.$loadingBar = loadingBar

  return <></>
}

export default LoadingBarContent
